import React, { useState, Component, createRef } from "react";
import PopUpItem from "../PopUp/PopUpItem";
import PopupArcode from "../PopUp/PopUpArcode";
import PopUpOther, { CreditCode } from "../PopUp/PopUpOther";
import PopUpSearchDoc, { ReDate } from "../PopUp/PopUpS_Cscustorder";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { parseJwt } from "../parseJWT";
import PopUpReport from "../PopUp/_fromShow";
import PopUpReturnProduct from "../PopUp/PopUpReturnProduct";
import PopUpReturnProductSub2 from "../PopUp/PopUpReturnProductSub2";
import PopUpwarehouse from "../PopUp/PopUpwarehouse";
import "./../_css/App.css";
import PopUpSaveMoneyExp from "./../PopUp/PopUpSaveMoneyExp"
import { Button, Modal, Row, Grid, Col, Panel } from "react-bootstrap";
import { checkData } from '../_source/checkDatainput';
import { checkunit } from '../_source/checkUnit';
import axios from 'axios'
import Checkdocgroup from '../CustomFunction/Docgroup/Checkdocgroup'
import CheckAr from '../CustomFunction/Csar/GetAr'
import CheckUser from '../CustomFunction/Csuser/GetUser'
import CheckBrabchname from '../CustomFunction/Branch/Checkname'
import CheckDepartmentname from '../CustomFunction/Department/Checkname'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Gendocno from '../CustomFunction/Docno/GetDocno'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import cheackprice from '../CustomFunction/Product/ChackPrice'
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson'
import Checkdocno from './../CustomFunction/Docno/GetDocno'
import Checkmaingroup from './../CustomFunction/Product/Checkmaingroup'
import Inputtax from './../PopUp/FullScreendialogs/Components/Inputtax';
import Withholding from './../PopUp/FullScreendialogs/Components/Withholding'
import CheckTaxrate from './../CustomFunction/Docgroup/CheckTaxrate'
// import FullScreenDialog from "./../PopUp/FullScreendialogs"
import FullScreenDialogs from '../PopUp/FullScreendialogs/FullScreen'
import PopUpSelSaleRetReqRef from '../PopUp/FullScreendialogs/Components/PopUpSelSaleRetReqRef';
import SelectDatas from "./../PopUp/SelectData"
import Topbar from "../Components/Customtopbar/Topbar";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Moment from 'moment';
import CustomInputtext from "./../Components/CustomInput/Inputtext"
// const computerName = require('computer-name')


const rowTable = 300;
const defaultcode = '0';
const listmenu = [
  ["เลือกใบส่งของ/ใบกำกับ", "SelSaleRef3"],
  ["เลือกใบขอรับคืนสินค้า", "SelSaleRetReqRef"],
  ["บันทึกจ่ายคืนเงินสด", "cashRepayment"],
  ["ค้นหาสินค้าจากประวัติการขาย", "SelARDepositUse"],
  ["บันทึกภาษีหัก ณ ที่จ่าย", "TaxWithholding"],
  ["ภาษีซื้อ", "Inputtax"],
]
export default class Sale extends Component {

  constructor(props) {
    super(props);
    this.ARCODE = createRef();
    this.ARNAME = createRef();
    this.Groupdata_code = createRef();
    this.Groupdata = createRef();
    this.DeliNumber = createRef();
    this.CreditCode_code = createRef();
    this.CreditCode = createRef();
    this.Csuser_code = createRef();
    this.Csuser = createRef();
    this.Department_code = createRef();
    this.Department = createRef();
    this.SUMAMOUNT1 = createRef();
    this.Branch_code = createRef();
    this.Branch = createRef();
    this.DISCWORD = createRef();
    this.DISCAMOUNT = createRef();
    this.STOCKPROC = createRef();
    this.STOCKPROC_CODE = createRef();
    this.REFAMOUNT = createRef();
    this.DIFFAMOUNT = createRef();
    this.AFTERDISC = createRef();
    this.REMARK = createRef();
    this.TAXRATE = createRef();
    this.TAXNO = createRef();
    this.TAXAMOUNT = createRef();
    this.TOTALAMOUNT = createRef();
    this.SUMAMOUNT2 = createRef();
    this.DEBTAMOUNT = createRef();
    this.Arcode2 = createRef();
    this.state = {
      _saveStatus: "",
      TBLastClick: -1,
      C1_editable: false,
      siteCodeUser: "", // สาขาพนักงาน
      EventType: "",
      Typeofcar: "",
      deprositState: 0,
      address: "",
      CNTYPE: "1",
      SaleType: "0",
      _srefdoctype: "0",
      Groupdata: "",
      Groupdata1: "",
      tableother: [],
      Bonus: "0",
      Claim: "0",
      handleClose: false,
      show1: false,
      autoClose: 3600,
      Groupdata_txt: "",
      Department_txt: "",
      Branch_txt: "",
      ARSUBGROUP: "",
      isLoading: false,
      messagealert: "",
      openBackdrop: false,
      SelSaleRefopen: false,
      provenance: '',
      Notax: '',
      taxtype: '',
      taxtypecode: '',
      Actingonbehalf: '',
      Incometype: '',
      Incometypecode: '',
      Remark: '',
      Amountbeforetax: '',
      Payablecode: '',
      Payablename: '',
      inputtax: [],
      Refundablerate: '',
      Deductionconditions: "",
      Taxrate: "",
      Withholdingtax: "",
      Refundablevalue: '',
      Taxrefund: '',
      Totaltax: '',
      PROJECT: "",
      PriceType_code: defaultcode,
      // defaultselect: defaultcode,
      SaleDate: '',
      //ปิดเปิดวันที่
      OpenSaleDate: false,
      OpenTAXDATE: false,
      checkenableInput: [],
      cscncode: "",
      defaultvaluewarehouse: "",
      defaultwarehouse: "",
      defaultlocetion: "",
    };
  }
  /* เช็คข้อมูลตรงกับตารางหรือไม่ตรง */
  onClickDocNo = async () => {
    if (!this.state.DOCGROUP_code) {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
    }
    if (this.state.DOCGROUP_code) {
      //Checkdocno  
      await Checkdocno(this.state.DOCGROUP_code, "CSSALE").then(async (result1) => {
        if (result1 !== undefined) {
          this.DeliNumber.current.value = await result1
        } else {
          this.DeliNumber.current.value = ""
        }
      }).catch((err) => {
        this.DeliNumber.current.value = ""
        console.log(err);
      });
    } else {
      this.DeliNumber.current.value = "";
    }
  };
  onKeyDown = (e) => {
    console.log(e.target.name);
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value, false);
      }
      if (e.target.name === "ARCODE") {
        this.onAddValue("ARCODE", e.target.value);
      }
      if (e.target.name === "Department") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value
          break;
        case "Department":
          this.Department.current.value = this.Department_code.current.value
          break;
        case "Branch":
          this.Branch.current.value = this.Branch_code.current.value
          break;
        default:
          break;
      }
    }
  }
  onChange = (e) => {
    switch (e.target.name) {
      case 'Department':
        if (e.target.value === "") {
          this.setState({ Department_txt: "" })
          this.state.Department_txt = ""
        }
        break;
      case 'Branch':
        if (e.target.value === "") {
          this.setState({ Branch_txt: "" })
          this.Branch_code.current.value = ""
        }
        break;
      case 'Groupdata':
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" })
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
        }
        break;
      case 'ARCODE':
        if (e.target.value === "") {

          this.ARCODE.current.value = "";
          this.ARNAME.current.value = "";
        }
        break;
      default:
        break;
    }
  }
  onBlur = (e) => {
    if (e.target.name === "Groupdata") {
      this.Groupdata.current.value = this.state.Groupdata_txt;
    }
    if (e.target.name === "Department") {
      this.Department.current.value = this.state.Department_txt;
    }
    if (e.target.name === "Branch") {
      this.Branch.current.value = this.state.Branch_txt;
    }
  };

  componentDidMount() {
    //เช็คเปิดปิด textbox
    this.setState({ checkenableInput: JSON.parse(localStorage.getItem('checkoftxt')) })

    this.setState({ provenance: window.location.hostname === "localhost" ? '' : 'Web' })

    // console.log("window.location.hostname", window.location.hostname);
    // พิมพ์ใบเสร็จชั่วคราว  console.log("localStorage.getItem(docno)"+localStorage.getItem("docno"));
    if (localStorage.getItem("docno") && localStorage.getItem("countprint") === "1") {
      this._print(localStorage.getItem("docno"));
      localStorage.setItem("countprint", "0");
    }
    //------------------------------------------ get setcode user ---------------------------------------------
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    //------------------------------------------- set table ---------------------------------------------------
    this.setRow(rowTable);
    /* if (localStorage.getItem("UsernameTH")) { */
    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    // this.checkOpenDate("Csuser", SITECODESTR.User.CODE);
    this.onAddValue("Branch", SITECODESTR.User.SITECODE)
    console.log(localStorage.getItem("UsernameTH"));
    this.Csuser.current.value = localStorage.getItem("UsernameTH");
    this.setState({ Deliverydate: this.CalendarOnChange(new Date()) })
    setTimeout(() => {
      this.Cal_Price();
    }, 200);

    this.setState({ STOCKPROC: "0" })
    this.TAXRATE.current.value = "7.00";
    this.REFAMOUNT.current.value = (0).toFixed(2)
  }
  escapeRegExp(str) {
    return str.replace(/,/g, " ");
  }
  saveData = async () => {
    const parameter = new URLSearchParams();


    var C4Send;
    var C3Send;
    var data = []
    var dataTT = [];
    // เช็คข้อมูลในตาราง 
    for (let i = 0; i < this.state.products.length && this.state.products[i].productcode; i++) {
      C4Send = this.state.products[i].location ? this.state.products[i].location : "";
      C3Send = this.state.products[i].warehouse ? this.state.products[i].warehouse : "";
      dataTT[i] = {
        ProductCode: this.state.products[i].productcode,
        ProductName: this.escapeRegExp(this.state.products[i].productname),
        Location: C3Send,
        Warehouse: C4Send,
        UnitCode: this.state.products[i].unitcode,
        Quantity: this.state.products[i].quantity,
        SalePrice: this.state.products[i].saleprice,
        DiscountWord: this.state.products[i].discountword ? this.state.products[i].discountword : "",
        Amount: this.state.products[i].amount,
        DiscountAmount: this.state.products[i].discountamount ? this.state.products[i].discountamount : "",
        CnCode: this.state.products[i].CNCODE ? this.state.products[i].CNCODE : "",
        StockType: this.state.products[i].stocktype ? this.state.products[i].stocktype : "",
        RefLineID: this.state.products[i].refLineID ? this.state.products[i].refLineID : "",
        UnitName: this.state.products[i].unitname ? this.state.products[i].unitname : "",
        ItemTaxType: this.state.products[i].itemtaxtype ? this.state.products[i].itemtaxtype : "",
        ProductSet: this.state.products[i].PRODUCTSET ? this.state.products[i].PRODUCTSET : "",
        RefQTY: this.state.products[i].REFQTY ? this.state.products[i].REFQTY : "0",
        PkLotId: this.state.products[i].PK_LOTID === undefined ? "" : this.state.products[i].PK_LOTID,
        RefInvoice: this.state.products[i].REFINVOICE === undefined ? "" : this.state.products[i].REFINVOICE,
        ReturnPopup: this.state.products[i].returnpopup === undefined ? "" : this.state.products[i].returnpopup,
        DocNo: this.state.products[i].DOCNO === undefined ? "" : this.state.products[i].DOCNO,
        ProductSetCode: !this.state.products[i].PRODUCTSETCODE ? "" : this.state.products[i].PRODUCTSETCODE,
        RefDoctype: !this.state.products[i].REFDOCTYPE ? "" : this.state.products[i].REFDOCTYPE,
        RefDocNo: !this.state.products[i].REFDOCNO ? "" : this.state.products[i].REFDOCNO,
        RefLineId2: !this.state.products[i].REFLINEID2 ? "" : this.state.products[i].REFLINEID2
      }
      data.push(dataTT[i]);
    }
    parameter.append("listitem", JSON.stringify(data));

    var row = this.state.tableother
    var csApWtaxdata = []
    var csApWtaxdataprms = []
    // var BEFORETAX = 0
    // var TAXAMOUNT = 0
    for (let i = 0; i < row.length; i++) {
      if (row[i].Taxinvoice || row[i].Taxtype) {
        // BEFORETAX += Number(row[i].Amountbeforetax)
        // TAXAMOUNT += Number(row[i].Tax)
        csApWtaxdata[i] = {
          TaxInvoice: row[i].Taxinvoice ? row[i].Taxinvoice : "",
          InvoiceDate: row[i].Invoicedate,
          DateTime: row[i].Datetime,
          PayableCode: row[i].PayableCode,
          PayableName: row[i].PayableName,
          Remark: row[i].Remark,
          TaxRate: row[i].Taxrate,
          AmountBeforeTax: row[i].Amountbeforetax,
          Tax: row[i].Tax,
          TaxType: row[i].Taxtype,
          ActingOnBehalf: row[i].Actingonbehalf
        }
        csApWtaxdataprms.push(csApWtaxdata[i]);
      }
    }
    parameter.append("CSAPWTAX", JSON.stringify(csApWtaxdataprms));

    let datainputtax = []
    await this.Chkinputtax().then((result) => {
      datainputtax = result
    })

    parameter.append("muntitaxinput", JSON.stringify(datainputtax))

    // return

    var POSTBALANCE = ""
    if (Number(this.state.Bankexpend) > 0) {
      POSTBALANCE = "0"
    }
    if (Number(this.state.Cchqssum) > 0) {
      POSTBALANCE = "0"
    }
    if (Number(this.state.OtheIncomesum) > 0) {
      POSTBALANCE = "0"
    }
    console.log(Number(this.state.Expensessum));
    if (Number(this.state.Expensessum) > 0) {
      POSTBALANCE = "0"
    }

    // เช็คธนาคาร
    parameter.append("CSPAYCHQ", JSON.stringify(this.state.Cchqs))
    parameter.append("CSRECINCOME", JSON.stringify(this.state.OtheIncome))
    parameter.append("CSRECEXPENSE", JSON.stringify(this.state.Expenses))

    parameter.append("CHEQUEAMOUNT", !this.state.Cchqssum ? "" : this.state.Cchqssum);
    parameter.append("INCOMEAMOUNT", !this.state.OtheIncomesum ? "" : this.state.OtheIncomesum);
    parameter.append("EXPENDAMOUNT", !this.state.Expensessum ? "" : this.state.Expensessum);
    parameter.append("POSTBALANCE", POSTBALANCE);
    parameter.append("PETTYCASH", checkData("text", this.state.Pettycash))
    parameter.append("PETTYCASHCODE", checkData("text", this.state.Pettycashcode))
    parameter.append("ADVANCEPAYBAL", checkData("money", this.state.ADVANCEPAY))
    parameter.append("ADVANCEPAY", checkData("money", this.state.ADVANCEPAY))
    parameter.append("CASHAMOUNT", checkData("money", this.state.Cashbalance))
    parameter.append("BANKEXPEND", checkData("money", this.state.Bankexpend))
    parameter.append("BANKAMOUNT", checkData("money", this.state.Bankamount))
    parameter.append("BOOKNO", checkData("text", this.state.Bookno))
    parameter.append("BOOKDESC", checkData("text", this.state.BookDESC))

    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("TAXNO", this.TAXNO.current.value);
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("UPDATEUSER", localStorage.getItem("Username"));
    parameter.append("SALECODE", localStorage.getItem("Username"));
    parameter.append("OWNERCODE", localStorage.getItem("Username"));
    parameter.append("ARCODE", this.ARCODE.current.value.trim());
    parameter.append("ARNAME", this.ARNAME.current.value);
    parameter.append("TAXDATE", this.state.TAXDATE);
    parameter.append("STOCKPROC", this.state.STOCKPROC);
    parameter.append("CREDITCODE", this.CreditCode_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("BILLADDR", this.state.address);
    parameter.append("CALCWTAX", this.state.SaleType);
    parameter.append("TAXTYPE", this.state.PriceType_code);
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("SUMAMOUNT1", this.SUMAMOUNT1.current.value);
    parameter.append("DIFFAMOUNT", this.DIFFAMOUNT.current.value);
    parameter.append("SUMAMOUNT2", this.SUMAMOUNT2.current.value === "0.00" ? "0" : this.SUMAMOUNT2.current.value);
    parameter.append("DISCWORD", this.DISCWORD.current.value ? this.DISCWORD.current.value + "%" : "");
    parameter.append("DISCAMOUNT", this.DISCAMOUNT.current.value);
    parameter.append("AFTERDISC", this.AFTERDISC.current.value);
    // parameter.append("BATHSUMAMOUNT1", this.AFTERDISC.current.value);
    parameter.append("TAXRATE", this.TAXRATE.current.value);
    parameter.append("TAXAMOUNT", this.TAXAMOUNT.current.value);
    parameter.append("BATHTAXAMOUNT", this.TAXAMOUNT.current.value);
    parameter.append("TOTALAMOUNT", this.TOTALAMOUNT.current.value);
    parameter.append("BATHTOTALAMOUNT", this.TOTALAMOUNT.current.value);
    parameter.append("DEBTAMOUNT", this.DEBTAMOUNT.current.value);
    parameter.append("CNCODE", this.state.cscncode);
    let DEBTBALANCE = this.DEBTAMOUNT.current.value
    // if (Number(this.REFAMOUNT.current.value) > 0 || this.state.creditType === "C00") {
    if (this.CreditCode_code.current.value === "C00") {
      DEBTBALANCE = "0"
    }
    parameter.append("DEBTBALANCE", DEBTBALANCE);
    parameter.append("BATHDEBTAMOUNT", this.DEBTAMOUNT.current.value);
    parameter.append("REFAMOUNT", this.REFAMOUNT.current.value);
    parameter.append("CNTYPE", this.state.CNTYPE);
    parameter.append("Modelcode", checkData("text", this.state.model))
    parameter.append("Colorcode", checkData("text", this.state.colorcar));
    parameter.append("Brandcode", checkData("text", this.state.brandname));
    parameter.append("REMARK", this.REMARK.current.value);
    parameter.append("Arcode2", this.Arcode2.current.value);
    parameter.append("Check_Status", "");
    parameter.append("Activities", this.state.EventType);
    parameter.append("PSsale", this.state.Typeofcar);
    parameter.append("provenance", this.state.provenance);
    parameter.append("Ardeposit_No", "");
    parameter.append("_refdoctype", this.state._srefdoctype);
    parameter.append("COMPNAME", "")
    parameter.append("PROJECT", this.state.PROJECT)
    var Uststus = true;
    for (var pair of parameter.entries()) {
      if (typeof pair[1] === "undefined") {
        pair[1] = "";
      }
      console.log(pair[0], "===", pair[1]);
    }

    if (Uststus === true) {
      this.setState({ openBackdrop: true })
      let url = "CSSALERET/Save?user="
      // console.log(genpostURL(url));
      await axios.post(genpostURL(url), parameter).then(res => {
        // await axios.post(genpostURLTEST("/Save?user="), parameter).then(res => {
        console.log(res.data);
        if (res.data === "1") {
          // localStorage.setItem("docno", this.DeliNumber.current.value);
          // localStorage.setItem("countprint", "1");
          this.setState({ opensnackbar: true })
          this.setState({ color: "success" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "บันทึกสำเร็จ" })
          this.setState({ openBackdrop: false })
          setTimeout(() => {
            this.setState({ openBackdrop: false })
            this.ResetThisPage();
          }, 30);
        } else {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "บันทึกข้อมูลไม่สำเร็จ" + res.data })
          this.setState({ openBackdrop: false })
        }
      }).catch(error => {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
        this.setState({ openBackdrop: false })
      });
    }
  };
  Chkinputtax = async () => {
    var inputtax = []
    var rsInputTax = []
    if (this.state.inputtax.length > 0) {
      for (var i = 0; i < this.state.inputtax.length && this.state.inputtax[i].Taxinvoice; i++) {
        if (this.state.inputtax[i].Taxinvoice != "") {
          inputtax[i] = {
            TaxInvoice: this.state.inputtax[i].Taxinvoice,
            PayableCode: this.state.inputtax[i].PayableCode,
            PayableName: this.state.inputtax[i].PayableName,
            TaxDescription: this.state.inputtax[i].Taxdescription,
            AmountBeforeTax: this.state.inputtax[i].Amountbeforetax,
            Tax: this.state.inputtax[i].Tax,
            TaxIncluded: this.state.inputtax[i].Taxincluded,
            InvoiceDate: (Moment(this.state.inputtax[i].Invoicedate, 'DD/MM/YYYY').add(-543, 'year').format('YYYY-MM-DD')),
            B_TAXRATE: this.state.inputtax[i].B_TAXRATE,
            B_AMOUNT: this.state.inputtax[i].B_AMOUNT,
            B_TAXAMOUNT: this.state.inputtax[i].B_TAXAMOUNT
          }
          rsInputTax.push(inputtax[i]);
        }
      }
    }
    return rsInputTax
  }
  ResetThisPage = () => {
    window.location.replace("/PSSaleRet");
  };
  /*----------------------------------------------------------------------------------------------------------------------------*/
  SelectSetData = async (data1, data2, rowIndex) => {
    switch (data1) {
      case "Calendar":
        this.setState({ SaleDate: data2 })
        break;
      case "Calendar2":
        this.state.TAXDATE = data2;
        break;
      case "PriceType":
        this.setState({ PriceType_code: await String(data2) })
        this.ReLoadData()
        break;
      case "PriceReturnType":
        this.setState({ CNTYPE: data2 });
        break;
      case "STOCKPROC":
        // this.STOCKPROC.current.value = checkInput("STOCKPROC", data2)
        // this.STOCKPROC_CODE.current.value = data2
        this.setState({ STOCKPROC: data2 });
        break;
      case "SaleType":
        this.setState({ SaleType: data2 });
        break;
      case "PROJECT":
        this.setState({ PROJECT: data2 })
        break
      case "cscncode" + rowIndex:
        console.log(data2);
        if (rowIndex === "") {
          this.setState({ cscncode: data2 })
          for (let i = 0; i < this.state.products.length; i++) {
            if (this.state.products[i].productcode) {
              this.state.products[i].CNCODE = data2
            }
          }
        }
        if (rowIndex !== "") {
          this.state.products[Number(rowIndex)].CNCODE = data2
        }
        break;
      default:
        break;
    }
  };
  confirm = () => {
    console.log("sssss confirm", this.state.SelSaleRefopen)
    if (this.state.SelSaleRefopen === false) {
      var col = this.state.products;
      for (var i = 0; i < col.length; i++) {
        if (col[i].productcode) {
          this.setState({ show1: true })
        }
      }
    }
  }
  _pricetype = async (Texttype) => {
    let strTexttype = String(Texttype)
    // this.setState({ defaultselect: [strTexttype] })
    this.setState({ PriceType_code: await strTexttype });
    this.Cal_Price();
  };
  //data.Customercode, data.Customername, data.Creditcode, data.Texttype, data.Address, data._accountcdoe, data._Prefis, data._Arname, data._Surname, data._argroup
  Get_PopUparcode = (ARCODE, ARNAME, Creditcode, Texttype, _address, accountcode, _prefis, _Arname, _Surname, _armaingroup, _arsubgroup1) => {
    console.log(_armaingroup, "==", _arsubgroup1);
    // console.log("_arsubgroup1", _arsubgroup1)
    this.setState({ _armaingroup: _armaingroup })
    this.setState({ _arsubgroup1: _arsubgroup1 })
    this.setState({ customer1: ARCODE })
    this.ARCODE.current.value = ARCODE;
    this.ARNAME.current.value = ARNAME;
    this.setState({ address: _address });
    this._pricetype(Texttype);
    setTimeout(() => {
      this.setCNTYPE(Creditcode)
      this.CreditCode_code.current.value = Creditcode;
      this.CreditCode.current.value = CreditCode(Creditcode);
      //TAXTYPE
    }, 30);
    this.confirm()
  };
  Get_PopUpOther = async (val) => {
    var data = val.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.onAddValue("Groupdata", data[0], false)
        break;
      case "CreditCode":
        this.CreditCode_code.current.value = data[0];
        this.CreditCode.current.value = data[1];
        setTimeout(() => {
          if (data[0] === "C00") {
            this.setState({ CNTYPE: "0" });
          } else {
            this.setState({ CNTYPE: "1" });
          }
        }, 100);
        break;
      case "Department":
        this.Department_code.current.value = data[0];
        this.Department.current.value = data[1];
        this.setState({ Department_txt: data[1] });
        break;
      case "Branch":
        this.Branch_code.current.value = data[0];
        this.Branch.current.value = data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      case "EventType":
        this.EventType.current.value = data[1];
        this.setState({ EventType: data[0] });
        break;
      case "typeofcar":
        this.typeofcar.current.value = data[1];
        this.setState({ Typeofcar: data[0] });
        break;
      default:
        break;
    }
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);
    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };
  get_PopUpSaveMoney = async (cash, recchq, csexpenses, csotherincome
  ) => {

    let Cchqssum = 0
    let Expensessum = 0
    let Otherincomesum = 0
    recchq.forEach(element => {
      Cchqssum += Number(element.Chqamount)
    });
    csexpenses.forEach(element => {
      Expensessum += Number(element.Expensesamount)
    });
    csotherincome.forEach(element => {
      Otherincomesum += Number(element.IncomeAmount)
    });


    await this.setState({
      //  เลขบัญชี
      Bookno: cash[0].Bookno,
      // ยอเงินโอน
      Bankamount: cash[0].Bankamount,
      // ค่าธรรมเนียม 
      Bankexpend: cash[0].Bankexpend,
      // หมายเหตุการโอนเงิน
      BookDESC: cash[0].Transferremark,
      //ยอดเงินสด
      Cashbalance: cash[0].Cashbalance,
      //เงินทดลองจ่าย
      ADVANCEPAY: cash[0].Advanceamount,
      //รหัสเงินสดย่อย
      Pettycashcode: cash[0].Pettycashcode,
      //ยอดเงินสดย่อย
      Pettycash: cash[0].Pettycashvalue,

      Expenses: csexpenses,
      Expensessum: Expensessum,

      Cchqs: recchq,
      Cchqssum: Cchqssum,
      OtheIncome: csotherincome,
      OtheIncomesum: Otherincomesum,

    })

    await this.saveData()


  }

  _cellButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].btn1;
    var btnShow = "this.state.products";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => this.Switch_PopUpItem("Search_Table")}
            onMouseDown={(e) => { this.setState({ TBLastClick: row.C0 }); }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  _cellButton_btn_C3 = (cell, row, enumObject, rowIndex) => {
    // console.log("_cellButton_btn_C4 active" + this.state.products[rowIndex].btn_C4);
    var btn = this.state.products[rowIndex].btn_C3;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButton_btn_C4 = (cell, row, enumObject, rowIndex) => {
    // console.log("_cellButton_btn_C4 active" + this.state.products[rowIndex].btn_C4);
    var btn = this.state.products[rowIndex].btn_C4;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ products: data });
  };
  rowClassNameFormat = (row, rowIdx) => {
    return "trClassName";
  };
  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.productcode })
    this.setState({ id: id })
    var Pr = this.state.products;
    var j = rowTable;
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });
    this.setState({ reduce: false });
    // จำนวนเต็มเวลาคลิก
    let quantity = row.quantity, saleprice = row.saleprice;
    if (col === 10 && quantity !== "" && quantity !== undefined) {
      row.quantity = parseFloat(quantity).toFixed(0)
    } else if (col === 11 && saleprice !== "" && saleprice !== undefined) {
      row.saleprice = parseFloat(saleprice).toFixed(0)
    }
    var CH = false;
    switch (col) {
      case 5: case 6: CH = true; break;
    }
    if (CH === true) {
      this.setState({ WHRow: id });
    } //set rowclick

    for (var i = 0; i < Pr.length; i++) {
      Pr[i].btn1 = 0;
      Pr[i].btn_C3 = 0;
      Pr[i].btn_C4 = 0;
    }

    // หาจากล่างขึ้นบน
    for (var i = this.state.products.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!this.state.products[i].productcode) { j = i; }
    }

    // BTN ค้นหาได้เฉพาะในแถว
    if ((col === 1 && j === id) || (col === 1 && Pr[id].productcode !== undefined && Pr[id].productcode !== "")) {
      this.setState({ col1: true });
      this.setState({ C1_editable: true });
      Pr[id].btn1 = 1;
    } else if (col === 5 && typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_C3 = 1;
    } else if (col === 7 && typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_C4 = 1;
    } else {
      this.setState({ C1_editable: false });
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ col: true });
      // BTN วันที่
    }
    if (this.state.Bonus === "0" && this.state.Claim === "0") {
      this.setState({ reduce: true });
    }

    this.setState({ products: Pr });
  };
  onAfterSaveCell = (row, cellName, cellValue) => {
    this.setState({ row: row.C0 - 1 })
    var cellValue1 = this.state.cellValue
    // ทศนิยม 2 ตำแหน่ง ปริมาณ 
    let saleprice = row.saleprice;
    if (cellName === "quantity" && cellValue !== "") {
      if (row.PRODUCTSET === "1") {
        for (let i = 0; i < this.state.products.length && this.state.products[i].productcode; i++) {
          console.log(this.state.products[i].PARENTCODE, "===", row.productcode);
          if (this.state.products[i].PARENTCODE === row.productcode) {
            this.state.products[i].quantity = parseFloat((Number(this.state.products[i].quantity1) * Number(row.quantity))).toFixed(2)
          }
        }
      }
      row.quantity = parseFloat(cellValue).toFixed(2)
      this.ReLoadData2(row.productcode);
    } else if (cellName === "saleprice" && saleprice !== "") {
      row.saleprice = parseFloat(saleprice).toFixed(2)
      this.ReLoadData();
    }
    if (cellName === "productcode" && cellValue !== "" && cellValue1 !== cellValue) {
      var col = this.state.products;
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      col[row.C0 - 1].productcode = "";
      col[row.C0 - 1].btn1 = row.btn1;
      this.setState({ products: col });
      this.AddDataTable(cellValue, row.C0 - 1, "", "");
    } else if (cellName === "productcode" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    } else if ((cellName === "quantity" && cellValue !== "") || (cellName === "discountword" && cellValue !== "") || (cellName === "saleprice" && cellValue !== "")) {
      //  this._chkdiscount(row, cellValue);
      var col = this.state.products;
      this._chkGroup(col[row.C0 - 1].productcode, col[row.C0 - 1].C0);
      setTimeout(() => {
        let str = "" + cellValue;
        var res = str.match("%");
        if (res) {
          let newstr = str.split("%");
          if (newstr[0] * 1 > 100) {
            col[col[row.C0 - 1].C0 - 1].discountword = "100%";
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "สินค้ารหัส " + col[row.C0 - 1].productcode + "ส่วนลดใส่ได้ไม่เกิน 100% " })
          }
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
      }, 250);
      setTimeout(() => {
        this.ReLoadData();
      }, 300);
    }
  };
  AddDataTable2() {
    var col = this.state.products;
    for (let i = 0; i < col.length; i++) {
      if (col[i].productcode !== undefined) {
        let dateSp = this.state.SaleDate;
        let docdate = "DocDate=" + String(dateSp).trim();
        let arcode = "&arcode=" + this.ARCODE.current.value.trim();
        let productcode = "&PRODUCTCODE=" + col[i].productcode;
        let quantity = "&QUANTITY=" + parseFloat(col[i].quantity).toFixed(0);
        let unitcode = "&UNITCODE=" + col[i].unitcode;
        let creditcode = "&CREDITCODE=" + this.CreditCode_code.current.value;
        let taxtype = "&TAXTYPE=" + this.state.PriceType_code
        let url = "GETPRICE/GET_CSF_GETARSTDPRICE?" + docdate + arcode + productcode + quantity + unitcode + creditcode + taxtype;
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then((res) => {
          col[i].saleprice = parseFloat(Number(res.data[0].UNITPRICE)).toFixed(2);
          this.ReLoadData()
        })
      }
    }
  }
  _chkGroupproduct(val, row) {
    // เช็คกลุ่มสินค้า
    let url =
      "CSPRODUCT/CHKGroup?code=" +
      val +
      "&user=" +
      localStorage.getItem("Username");
    let loadname = "load" + row - 1;
    // var j = rowData;
    var col = this.state.products;
    axios.get(genURL(url), { timeout: 60000 }).then((res) => {
      if (res.data.length > 0) {
        for (var i = 0; i < res.data.length; i++) {
          this.setState({ groupNumber: res.data[i].MAINGROUP });
        }
      }
    });
  }

  Get_PopUpItem = (code, data, stocktype) => {
    this.AddDataTable(code, this.state.TBLastClick - 1, data, stocktype);
  };
  // checkuserField = (productcode) => { // -------------- เช็ค user field-------------------------
  //   let url = "CSPRODUCT/ProductFullbycode?code=" + productcode
  //   console.log(genURL(url));
  //   axios.get(genURL(url), { timeout: 60000 }).then((res) => {
  //     for (let index = 0; index < res.data.length; index++) {
  //       console.log(res.data);
  //       // this.machineNumber.current.value = res.data[index].MachineNo
  //       // this.MTSerialNo.current.value = res.data[index].SerialNo
  //     }
  //   })
  // }
  AddDataTable = (ItemCode, row, data, stocktype) => {
    var col = this.state.products;
    var url = "CSPRODUCT/GetAllProductcode?code=" + ItemCode + "&user=" + localStorage.getItem("Username");
    console.log("GetAllProductcode", genURL(url));
    axios.get(genURL(url), { timeout: 3600 }).then(async (ref) => {

      console.log("GetAllProductcode", ref.data);
      var j = 0;
      if (row > -1) {
        j = row;
      } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
        j = this.state.TBLastClick - 1;
      } else {
        for (var i = this.state.products.length - 1; i >= 0; i--) {
          // หาจากล่างขึ้นบน
          if (!this.state.products[i].productcode) {
            j = i;
          }
        }
      }
      if (ref.data.length > 0) {
        for (let index = 0; index < ref.data.length; index++) {
          // let Discountword;
          // if (this.state.selectclaim === true || this.state.selectgiveaway === true) {
          //   Discountword = (Number(ref.data[index].STOCKQTY) * Number(ref.data[index].SALELASTPRICE)).toFixed(2)
          // } else {
          //   Discountword = (0).toFixed(2)
          // }
          var MAINGROUP = "";
          if (ref.data[index].PRODUCTSET !== 1) {
            var url1 = genURL("CSPRODUCT/Code?productset=" + ref.data[index].PRODUCTSET + "&stocktype=" + stocktype + "&code=" + ref.data[index].PRODUCTCODE)
            console.log("url1", url1);
            await axios.get(url1, { timeout: 3600 }).then(async (result) => {
              console.log(result.data);
              if (result.data.length > 0) {
                MAINGROUP = await result.data[0].MAINGROUP == undefined ? "" : result.data[0].MAINGROUP
              }
            })
          }
          // try {
          //   if (MAINGROUP === "01") {
          //     this.checkuserField(ref.data[index].PRODUCTCODE)
          //   }
          // } catch (error) { }

          var unit = ""
          await checkunit(ref.data[index].UNITCODE).then(data => {
            unit = data
            console.log(unit);
          })
          var saleprice = "0.00"
          await cheackprice(ref.data[index].PRODUCTCODE, 1, this.ARCODE.current.value, ref.data[index].UNITCODE, ref.data[index].ITEMTAXTYPE, this.state.SaleDate, this.CreditCode_code.current.value).then((res) => {
            console.log(res);
            if (res !== undefined) {
              saleprice = parseFloat(res).toFixed(2)
            }
          }).catch((err) => {
            console.log(err);
          });
          col[j] = {
            C0: j + 1,
            productcode: ref.data[index].PRODUCTCODE,
            btn1: col[0].btn1,
            productname: ref.data[index].PRODUCTNAME,
            warehouse: this.state.defaultwarehouse,
            location: this.state.defaultlocetion,
            unitname: unit,
            unitcode: ref.data[index].UNITCODE,
            quantity: ref.data[index].QUANTITY ? ref.data[index].QUANTITY : "",
            quantity1: ref.data[index].QUANTITY ? ref.data[index].QUANTITY : 0,
            saleprice: ref.data[index].PRODUCTSET === 1 ? "" : saleprice,
            discountword: ref.data[index].DISCWORD,
            amount: ref.data[index].PRODUCTSET === 1 ? "" : saleprice,
            CNCODE: "",
            stocktype: ref.data[index].STOCKTYPE,
            productgroup: MAINGROUP,
            itemtaxtype: ref.data[index].ITEMTAXTYPE,
            PARENTCODE: ref.data[index].PARENTCODE,
            PRODUCTSET: ref.data[index].PARENTCODE == ref.data[0].PRODUCTCODE ? "2" : String(ref.data[index].PRODUCTSET),
            REFQTY: "0",
            PRODUCTSETCODE: ref.data[index].PRODUCTSETCODE
          };
          j++
          this.setState({ products: col });
          this.ReLoadData()

          // this.ReLoadData2(ref.data[index].PRODUCTCODE)

          // } else {
          //   this.setState({ opensnackbar: true })
          //   this.setState({ color: "warning" })
          //   this.setState({ icon: ErrorIcon })
          //   this.setState({ messagealert: "จำนวนสินค้าไม่พอสำหรับทำรายการ" })

          // }
        }
      } else {
        // this.ReLoadData();
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" })
      }
    });
    setTimeout(() => {
      document.getElementById("TableLoadItem").innerHTML = "";
    }, 3000);
  };
  // search ราคาขาย
  ReLoadData2 = (arcode) => {
    var i = this.state.row
    var col = this.state.products;
    var dateSp = this.state.SaleDate;
    let DocDate = "DocDate=" + String(dateSp).trim();
    let QUANTITY = "&QUANTITY=" + parseFloat(col[i].quantity).toFixed(0);
    let Customer = "&arcode=" + this.ARCODE.current.value.trim();
    let UNITCODE = "&UNITCODE=" + col[i].unitcode
    let taxtype = "&TAXTYPE=" + this.state.PriceType_code
    var url = "GETPRICE/GET_CSF_GETARSTDPRICE?" + DocDate + "&" + "PRODUCTCODE=" + arcode + QUANTITY + Customer + UNITCODE + taxtype;
    console.log(genURL(url));
    axios.get(genURL(url), { timeout: 60000 }).then((res) => {
      // console.log(i, "testtt", parseFloat(Number(res.data[0].UNITPRICE)).toFixed(2));
      col[this.state.row].saleprice = parseFloat(Number(res.data[0].UNITPRICE)).toFixed(2);
      this.ReLoadData()
    })
  }
  //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = async () => {
    var col = this.state.products;
    var NewCol = [];
    var j = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode) {
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        if (col[i].discountword === "-") {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        } else if (col[i].discountword === "") {
          NewCol[j].discountword = ""
        } else if (col[i].discountword * 1 > col[i].saleprice * col[i].quantity * 1) {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        }
        let str = "" + NewCol[j].discountword;
        var res = str.match("%");
        if (NewCol[j].quantity) {
          if (res) {
            let newstr = str.split("%");
            NewCol[j].amount = parseFloat(col[i].saleprice * col[i].quantity - col[i].saleprice * col[i].quantity * (newstr[0] / 100)).toFixed(2);
            NewCol[j].discountamount = parseFloat(col[i].saleprice * col[i].quantity * (newstr[0] / 100)).toFixed(2);
          } else {
            if (col[i].discountword * 1 > col[i].saleprice * col[i].quantity * 1) {
              NewCol[j].discountword = col[i].saleprice * col[i].quantity * 1;
            }
            let sum = col[i].saleprice * col[i].quantity * 1 - NewCol[j].discountword * 1;
            NewCol[j].amount = sum.toFixed(2);
            NewCol[j].discountamount = NewCol[j].discountword ? parseFloat(NewCol[j].discountword).toFixed(2) : (0).toFixed(2)
          }
        }
        j++;
      }
    }

    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    this.setState({ products: await NewCol });
    this.Cal_Price();
    // this.DISCAMOUNT.current.value = parseFloat(0).toFixed(2);
  };

  /* อันใหม่ */
  Cal_Price = (e) => {
    var SumPriceProduct = 0.0;
    var SumPriceProduct1 = 0.0
    var TAXRATE = Number(this.TAXRATE.current.value);
    var TaxPersen1 = 100 + TAXRATE;
    var DISCWORD = this.DISCWORD.current.value ? Number(this.DISCWORD.current.value) : 0
    // var REFAMOUNT = 0.00
    var DIFFAMOUNT = 0.00
    for (var i = 0; i < this.state.products.length; i++) {
      if (this.state.products[i].amount && this.state.products[i].PRODUCTSET !== "2") {
        SumPriceProduct1 += parseFloat(this.state.products[i].amount)
        this.DISCAMOUNT.current.value = parseFloat((SumPriceProduct1 * DISCWORD) / 100).toFixed(2)
        SumPriceProduct = SumPriceProduct1 - this.DISCAMOUNT.current.value
        // }
        //เลือกใบส่งของ/ใบกำกับ 
        // if (this.state.products[i].returnpopup === "1" || this.state.products[i].returnpopup === "2") {
        //   REFAMOUNT += Number(!this.state.products[i].amount ? 0.00 : this.state.products[i].amount)
        //   this.setState({ CNTYPE: "0" });
        // } else {
        DIFFAMOUNT += Number(!this.state.products[i].amount ? 0.00 : this.state.products[i].amount)
      }

    }

    // console.log(REFAMOUNT, DIFFAMOUNT);
    this.setState({ allpriceforTax_: SumPriceProduct });
    // this.DISCWORD.current.value = parseFloat(DISCWORD).toFixed(2)
    this.TAXRATE.current.value = parseFloat(TAXRATE).toFixed(2);
    //--------------------------------------เช็คประเภทภาษี------------------------------------------
    // ราคาไม่รวมภาษี
    console.log(this.state.PriceType_code);
    var taxamount = 0
    if (this.state.PriceType_code === "0") {

      this.AFTERDISC.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TAXAMOUNT.current.value = parseFloat(
        (SumPriceProduct * 7) / 100
      ).toFixed(2);
      taxamount = (SumPriceProduct * 7) / 100
      this.SUMAMOUNT1.current.value = parseFloat(SumPriceProduct1).toFixed(2);
      this.DEBTAMOUNT.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      this.TOTALAMOUNT.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      // ราคารวมภาษี
      // DIFFAMOUNT += Number(this.TAXAMOUNT.current.value)
      // DIFFAMOUNT = 0
    } else if (this.state.PriceType_code === "1") {
      //รวมภาษี
      //  console.log(TaxPersen1);
      // ภาษีมูลค่าเพิ่ม
      this.TAXAMOUNT.current.value = parseFloat((SumPriceProduct * TAXRATE) / TaxPersen1).toFixed(2);
      this.AFTERDISC.current.value = parseFloat(SumPriceProduct - Number(this.TAXAMOUNT.current.value)).toFixed(2);
      this.SUMAMOUNT1.current.value = SumPriceProduct1.toFixed(2);
      this.DEBTAMOUNT.current.value = SumPriceProduct.toFixed(2);
      this.TOTALAMOUNT.current.value = SumPriceProduct.toFixed(2);
      // ภาษีอัตราศูนย์
    } else {
      // ภาษีมูลค่าเพิ่ม
      this.TAXAMOUNT.current.value = "0.00";
      this.AFTERDISC.current.value = parseFloat(SumPriceProduct).toFixed(2);
      this.SUMAMOUNT1.current.value = SumPriceProduct1.toFixed(2);
      this.DEBTAMOUNT.current.value = SumPriceProduct.toFixed(2);
      this.TOTALAMOUNT.current.value = SumPriceProduct.toFixed(2);
    }
    this.DIFFAMOUNT.current.value = ((this.REFAMOUNT.current.value - (DIFFAMOUNT - Number(this.DISCAMOUNT.current.value) + taxamount))).toFixed(2)

    var SUMAMOUNT2 = 0
    if (this.SUMAMOUNT2.current.value) {
      SUMAMOUNT2 = parseFloat(this.SUMAMOUNT2.current.value).toFixed(2);
    } else {
      this.SUMAMOUNT2.current.value = "0.00"
    }
    this.setState({ AmountPayable: this.DEBTAMOUNT.current.value });
    setTimeout(() => {
      //เลือกใบส่งของ/ใบกำกับ 
      // if (DIFFAMOUNT) {
      //   this.DIFFAMOUNT.current.value = "-" + parseFloat(DIFFAMOUNT).toFixed(2);
      // }
      // if (REFAMOUNT) {
      //   this.REFAMOUNT.current.value = parseFloat(REFAMOUNT).toFixed(2);
      // }

    }, 100);
  };
  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  }
  onChangeData = (e) => {
    var Ref = this.state.LastRef;
    if (e.key === "Enter" && e.target.value !== "") {
      this.onAddValue(Ref, e.target.value).then((res) => {
        this.SwitchValue(Ref, "EnterEvent");
      });
    }
  };
  _chkGroup(val, row) {
    // เช็คกลุ่มสินค้า
    // console.log(this.state.codeGroup.substring(7, 8));
    try {
      var lastCode = this.state.codeGroup.substring(7, 8);
      this.setState({ lastCode_s_: lastCode });
    } catch (error) {
      this.setState({ lastCode_s_: 99 });
    }
    // console.log(lastCode);
    if (lastCode === 8) {
      let url =
        "CSPRODUCT/CHKGroup?code=" +
        val +
        "&user=" +
        localStorage.getItem("Username");
      // console.log(url);
      let loadname = "load" + row - 1;
      // var j = rowData;
      var col = this.state.products;
      axios.get(genURL(url), { timeout: 60000 }).then((res) => {
        if (res.data.length > 0) {
          for (var i = 0; i < res.data.length; i++) {
            // console.log(res.data[i].MAINGROUP);
            this.setState({ groupNumber: res.data[i].MAINGROUP });
          }
        }
      });
    } else {
      this.setState({ groupNumber: 99 });
    }
  }
  _chkdiscount = (row, cellValue) => {
    var col = this.state.products;
    this._chkGroup(col[row.C0 - 1].productcode, col[row.C0 - 1].C0);
    setTimeout(() => {
      this.setState({ products: col });
    }, 100);
    this.ReLoadData();
    // }, 300);
  };
  onAddValue = async (type, value, Fix) => {
    if (value) {
      switch (type) {
        case "Groupdata":
          // let text
          Checkdocgroup(value, "CSSaleRet").then((result) => {
            // here you can use the result of promiseB
            console.log("ssssss", result);
            this.Groupdata_code.current.value = value
            this.Groupdata.current.value = result
            this.setState({ Groupdata_txt: result })
            //text = result
          }).finally(_ => {
            CheckTaxrate(value, "CSSaleRet").then((result) => {
              console.log("sssss", result);
              this.TAXRATE.current.value = result
            })
          });
          setTimeout(() => {
            if (Fix === false) {
              this.GenerateDocno(value, "CSSaleRet")
            }
          }, 100);
          break;
        case "ARCODE":
          await CheckAr(value).then((result) => {
            if (result !== "") {
              let data = result.split("|")
              this.ARCODE.current.value = value
              this.ARNAME.current.value = data[0]
              this.CreditCode_code.current.value = data[1]
              this.CreditCode.current.value = CreditCode(data[1])
              this.setCNTYPE(data[1])
              this.setState({ _arsubgroup1: data[4] })
              this._pricetype(data[5]);
              this.confirm()

            } else {
              // AlertPopup("Warning", "ไม่พบข้อมูล!");
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูลลูกค้ากรุณาลองใหม่อีกครั้ง" })
              this.ARCODE.current.value = ""
              this.ARNAME.current.value = ""
              this.CreditCode_code.current.value = ""
              this.CreditCode.current.value = ""
              this.setState({ _arsubgroup1: "" })
            }
          }).catch((err) => {
            this.setState({ _arsubgroup1: "" })
            this.ARCODE.current.value = ""
            this.ARNAME.current.value = ""
            this.CreditCode_code.current.value = ""
            this.CreditCode.current.value = ""
            console.log(err);
          });
          break;
        case "Csuser":
          await CheckUser(value).then((result) => {
            if (result !== undefined) {
              this.Csuser_code.current.value = value
              this.Csuser.current.value = result
            } else {
              // AlertPopup("Warning", "ไม่พบข้อมูล!");
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูลพนักงานกรุณาลองใหม่อีกครั้ง" })

              this.Csuser_code.current.value = ""
              this.Csuser.current.value = ""
            }
          }).catch((err) => {
            this.Csuser_code.current.value = ""
            this.Csuser.current.value = ""
            console.log(err);
          });
          break;
        case "Department":
          CheckDepartmentname(value).then((result) => {
            //console.log("result",result); 
            this.Department_code.current.value = value
            this.Department.current.value = result
            this.setState({ Department_txt: result });
            this.setState({ Department_code: value });
            this.setState({ Department: result });
          });
          break;
        case "Branch":
          await CheckBrabchname(value).then((result) => {
            if (result !== undefined) {
              this.Branch_code.current.value = value
              this.Branch.current.value = result
              this.setState({ Branch_txt: result });
            } else {
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูลสาขากรุณาลองใหม่อีกครั้ง" })

              // AlertPopup("Warning", "ไม่พบข้อมูล!");
              this.Branch_code.current.value = ""
              this.Branch.current.value = ""
              this.setState({ Branch_txt: "" });
            }
          }).catch((err) => {
            this.Branch_code.current.value = ""
            this.Branch.current.value = ""
            this.setState({ Branch_txt: "" });
            console.log(err);
          }); break
        default:
          break;
      }
    }
  };
  setCNTYPE = (CNTYPE) => { this.setState({ CNTYPE: (CNTYPE === "C00" ? "0" : "1") }); }
  GenerateDocno(value, table) {
    Gendocno(value, table).then((result) => {
      this.DeliNumber.current.value = result
      this.TAXNO.current.value = result
    })
  }
  _reCHK = (RowData) => {
    this.CloseDialog(false)
    this.setRow(rowTable);
    this.setState({ _saveStatus: true });
    console.log(RowData);
    var url = genURL("CSSALERET/Pageserachmain?code=" + RowData.DOCNO)
    console.log(url);
    axios.get(url, { timeout: 60000 }).then((res) => {
      console.log(res.data[0].Arcode2);
      if (res.data.length === 1) {
        this.onAddValue("Branch", res.data[0].SITECODE);
      }
      this.setState({ defaultvaluewarehouse: "รหัสคลัง: " + res.data[0].SITECODE + "  รหัสที่เก็บ: " + res.data[0].SITECODE + "001" })

      this._pricetype(res.data[0].TAXTYPE);

      this.ARCODE.current.value = res.data[0].ARCODE
      this.ARNAME.current.value = res.data[0].ARNAME
      this.onAddValue("Groupdata", res.data[0].DOCGROUP, true)
      this.DeliNumber.current.value = res.data[0].DOCNO
      this.TAXNO.current.value = res.data[0].TAXNO ? res.data[0].TAXNO : "";
      this.CreditCode_code.current.value = res.data[0].CREDITCODE
      this.CreditCode.current.value = CreditCode(res.data[0].CREDITCODE)
      this.setState({ SaleDate: ReDate(res.data[0].DOCDATE) })
      this.REMARK.current.value = RowData.remark
      this.onAddValue("Csuser", res.data[0].SALECODE)
      this.onAddValue("Department", res.data[0].DEPARTMENT)
      this.setState({ Department: res.data[0].DEPARTMENT })
      /*-----------------------------------------------------------------*/
      this.Arcode2.current.value = res.data[0].Arcode2 ? res.data[0].Arcode2 : "";
      this.DIFFAMOUNT.current.value = res.data[0].DIFFAMOUNT
      this.SUMAMOUNT2.current.value = res.data[0].SUMAMOUNT2
      /* this.SUMAMOUNT2.current.value = res.data[0].EXCHANGERATE */
      this.SUMAMOUNT1.current.value = res.data[0].SUMAMOUNT1
      this.DISCWORD.current.value = res.data[0].DISCWORD
      this.DISCAMOUNT.current.value = res.data[0].DISCAMOUNT
      this.AFTERDISC.current.value = res.data[0].AFTERDISC
      this.TAXRATE.current.value = res.data[0].TAXRATE
      this.TAXAMOUNT.current.value = res.data[0].TAXAMOUNT
      this.TOTALAMOUNT.current.value = res.data[0].TOTALAMOUNT
      this.DEBTAMOUNT.current.value = res.data[0].BATHDEBTAMOUNT
    });
    var url1 = "CSSALERET/Pageserachsub?code=" + RowData.DOCNO;
    console.log(genURL(url1));
    axios.get(genURL(url1), { timeout: 60000 }).then(async res => {
      if (res.data) {
        var data = this.state.products;
        for (var i = 0; i < res.data.length; i++) {
          var unit = ""
          await checkunit(res.data[i].UNITCODE).then(data => { unit = data })
          data[i].productcode = res.data[i].PRODUCTCODE;
          data[i].productname = res.data[i].PRODUCTNAME;
          data[i].warehouse = res.data[i].SITECODE;
          /* data[i].location = res.data[i].SITECODE + "1"; */
          data[i].location = res.data[i].LOCATION;
          data[i].unitcode = res.data[i].UNITCODE;
          data[i].unitname = unit
          /*   ? res.data[i].STOCKUNIT: res.data[i].UNITCODE; */
          data[i].quantity = res.data[i].QUANTITY;
          data[i].saleprice = res.data[i].AMOUNT;
          data[i].discountword = res.data[i].DISCAMOUNT;
          data[i].amount = res.data[i].NETAMOUNT;
          data[i].CNCODE = res.data[i].DIMENSION1;
          data[i].REFINVOICE = res.data[i].REFINVOICE;
          if (i === res.data.length - 1) {
            await this.setState({ products: data })
            this.Cal_Price()
          }
        }
      }
    });
  };
  /*----------------------------------------------------------Switch------------------------------------------------------------------*/
  Switch_PopUpItem = (e) => {
    // this.setState({ SwitchPopUpItem: !this.state.SwitchPopUpItem });
    this.setState({ typeFullScreenDialogs: e })
    //open
    this.setState({ openFullScreenDialogs: true })
    //title
    this.setState({ titleFullScreenDialogs: "ค้นหาสินค้า-product" })
  };
  Switch_PopupArcode = (e) => {
    // this.setState({ SwitchPopupArcode: !this.state.SwitchPopupArcode });
    //ชื่อ
    this.setState({ typeFullScreenDialogs: e })
    //open
    this.setState({ openFullScreenDialogs: true })
    //title
    this.setState({ titleFullScreenDialogs: "ค้นหาลูกค้า-AR" })
  };
  Switch_OtherPopup = (e) => {
    this.setState({ OtPopupType: e });
    // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    //ชื่อ
    this.setState({ typeFullScreenDialogs: e })
    //open
    this.setState({ openFullScreenDialogs: true })
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdocgroup" })
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdepartment" })
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-cssite" })
    }
    if (e === "CreditCode") {
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-creditcode" })
    }
  };
  _print = (val) => {
    if (this.DeliNumber.current.value !== "") {
      this._callForm(
        this.CreditCode_code.current.value,
        this.DeliNumber.current.value
      );
    } else if (val !== "") {
      this._callForm(this.CreditCode_code.current.value, val);
    } else {
      // AlertPopup("Warning", "ไม่อยู่ในเงื่อนไขการพิมพ์");
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "ไม่อยู่ในเงื่อนไขการพิมพ์" })
      return;
    }
    // this.setState({ SwitchReport: !this.state.SwitchReport });
  };
  _callForm = (vel, val1) => {
    let url1 = "https://csrpt.pspl.co.th/jasperserver/";
    let url2 =
      "&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf";
    let url3 = "&docno=" + val1;

    switch (vel) {
      case "C00": //***เงินสด
        this.setState({
          urlsend:
            url1 +
            "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FPSMT_CSSALEFRONTCASH&standAlone=true" +
            url2 +
            url3,
        });
        break;
      default:
        //เงินผ่อน
        this.setState({
          urlsend:
            url1 +
            "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FPSMT_CSSALEFRONTCREDIT&standAlone=true" +
            url2 +
            url3,
        });
        break;
    }
    setTimeout(() => {
      if (this.state.urlsend !== null) {
        console.log(this.state.urlsend);
        this.switchshowform();
      }
    }, 100);
  };
  //------------------------------------------------------------------------
  Switch_SelSaleRef3 = (e) => {
    this.setState({ SelSaleRefopen: true })
    if (this.ARCODE.current.value) {
      //ชื่อ
      this.setState({ typeFullScreenDialogs: "Search_CSVINVSALEREF" })
      //open
      this.setState({ openFullScreenDialogs: true })
      //title
      this.setState({ titleFullScreenDialogs: "ค้นหาใบส่งของ/ใบกำกับภาษี-SellnvSaleRef" })
      // this.setState({ SwitchSelSaleRef3: true });
    } else {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณาใส่! รหัสลูกค้า" })
    }
  };
  Switch_SelARDepositUse = (e) => {
    if (!this.ARCODE.current.value) {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณาใส่! รหัสลูกค้า" })
    } else {
      this.setState({ PopUpTYpeSelARDepositUse: e });
      //ชื่อ
      this.setState({ typeFullScreenDialogs: "CSSELSALERETREQREF" })
      //open
      this.setState({ openFullScreenDialogs: true })
      //title
      this.setState({ titleFullScreenDialogs: "ค้นหาใบส่งของ/ใบกำกับภาษี-SellnvSaleRef" })
      // this.setState({  SwitchSelARDepositUse: !this.state.SwitchSelARDepositUse,});
    }
  };
  Switch_PopUpwarehouse = (type) => {
    console.log("case setwarehousetable");
    switch (type) {
      case "setwarehousetable":
        if (this.state.productcodeinrow !== "") {
          // this.setState({
          //   SwitchPopUpwarehouse: !this.state.SwitchPopUpwarehouse,
          // });
          // this.setState({ PopUpWHType: type });

          this.setState({ PopUpWHType: type })
          //ชื่อ
          this.setState({ typeFullScreenDialogs: type })
          //open
          this.setState({ openFullScreenDialogs: true })
          //title
          this.setState({ titleFullScreenDialogs: "เลือกคลังและตำแหน่งเก็บ" })
        } else {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" })
          return;
        }

        break;
    }
  };

  // จัดการข้อมูลหลังจากดึงกลับมาจากป๊อบอัพ
  Get_SelSaleRef3 = async (data, data1, creditCode, department, sitecode, salecode, DEBTAMOUNT) => {
    this.CloseDialog(false)
    this.REFAMOUNT.current.value = Number(DEBTAMOUNT).toFixed(2)
    //เลือกใบส่งของ/ใบกำกับ 
    var returnpopup = "0"
    if (salecode) {
      returnpopup = "1"
    }
    this.setState({ SwitchSelSaleRef3: false });
    let row = this.state.products;
    var j = this.state.products.length
    console.log(j);
    for (let id = 0; id < data.length; id++) {
      row[j] = {
        productcode: data[id].Col2,
        productname: data[id].Col3,
        REFINVOICE: data[id].Col1,
        warehouse: data[id].Col13,
        location: data[id].Col14,
        unitname: data[id].Col4,
        unitcode: data[id]._unitCode,
        quantity: data[id].QUANTITY,
        saleprice: data[id].UNITPRICE,
        discountword: parseFloat(Number(data[id].Col9)).toFixed(2),
        refLineID: data[id]._refLineID,
        productgroup: data[id].maingroup,
        stocktype: data[id].STOCKTYPE,
        itemtaxtype: data[id].ITEMTAXTYPE ? data[id].ITEMTAXTYPE : "0",
        PRODUCTSET: data[id].productset,
        REFQTY: data[id].REFQTY,
        PK_LOTID: data[id].PK_LOTID,
        returnpopup: returnpopup,
        REFDOCTYPE: data[id].REFDOCTYPE,
      }
      j++
    }
    this.setState({ products: row });

    setTimeout(() => {
      if (creditCode !== "") {
        this.CreditCode_code.current.value = creditCode;
        this.CreditCode.current.value = CreditCode(creditCode);
        if (creditCode === "C00") {
          this.setState({ CNTYPE: "0" });
        } else {
          this.setState({ CNTYPE: "1" });
        }
      }
      if (department !== "") {
        this.onAddValue("Department", department);
      }
      if (sitecode !== "") {
        this.onAddValue("Branch", sitecode);
      }
      // console.log(data1);
      // if (data1 !== "") {
      //   this._pricetype(data1);
      // }
      this.ReLoadData();
    }, 300);
  }


  ///-------------------------------------save data ----------------------------------------------
  _connectsaveData = () => {
    if (this.ARCODE.current === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า ...!" })
      return;
    }
    if (this.ARNAME.current === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า ...!" })
      return;
    }
    if (this.state.SaleDate === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณาเลือกวันที่ขอคืน ...!" })
      return;
    }
    if (this.DeliNumber.current === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกใบขอรับคืน ...!" })
      return;
    }
    if (this.state.PriceType_code === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณาเลือกประเภทราคา ...!" })
      return;
    }
    if (this.CreditCode.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "CreditCode ต้องไม่เท่ากับค่าว่าง" })
      return
    }
    if (this.Groupdata.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กลุ่มข้อมูล ต้องไม่เท่ากับค่าว่าง" })
      return
    }
    if (this.Department_code.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกข้อมูลแผนก" })
      return
    }
    if (this.Branch_code.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกข้อมูลสาขา" })
      return
    }
    if (!this.state.products[0].productcode) {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณาเพิ่มข้อมูลสินค้า ...!" })
      return;
    }

    var C4Send;
    var C3Send;
    // เช็คข้อมูลในตาราง 
    for (let i = 0; i < this.state.products.length && this.state.products[i].productcode; i++) {
      C4Send =
        typeof this.state.products[i].location !== undefined
          ? this.state.products[i].location
          : "";
      C3Send =
        typeof this.state.products[i].warehouse !== undefined
          ? this.state.products[i].warehouse
          : "";
      if (this.state.products[i].stocktype === 0) {
        if (C3Send === "") {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "กรุณาเลือกคลัง" })
          return;
        }
        if (C4Send === "") {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บ" })
          return;
        }
      }
      if (this.state.products[i].saleprice === "" || typeof this.state.products[i].saleprice === "undefined") {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณาตรวจสอบราคาสินค้า แถวที่ " + (i + 1) + " อีกครั้ง" })
        return;
      }

      if (this.state.products[i].quantity === "" || typeof this.state.products[i].quantity === "undefined") {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณาตรวจสอบปริมาณสินค้า แถวที่ " + (i + 1) + " อีกครั้ง" })
        return;
      }
      if (this.state.products[i].amount === "" || typeof this.state.products[i].amount === "undefined") {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณาตรวจสอบราคารวมของสินค้า แถวที่ " + (i + 1) + " อีกครั้ง" })
        return;
      }
    }
    if (this.CreditCode_code.current.value === "C00" && Number(this.DEBTAMOUNT.current.value) > 0) {
      this.setState({ PopUpSaveMoney: true })
    } else {
      this.saveData()
    }
  };

  //------------------------------- คำนวนส่วนลดรวม--------------------------------------
  _calculatdiscount = () => {
    if (this.DISCWORD.current.value === "") {
      this.ReLoadData();
      // this.DISCWORD.current.value=parseFloat(0).toFixed(2);
      this.DISCAMOUNT.current.value = parseFloat(0).toFixed(2);
      this.DISCWORD.current.value = "";
      this.REFAMOUNT.current.value = "";
      // this.setState({ allpriceforTax_: this.SUMAMOUNT1.current.value});// เอาไว้ใช้คำนวนเบี้ยใหม่
      // setTimeout(() => {
      // }, 100);
    } else {
      // -----------------------------ส่วนลด-------------------------------------------------------
      let chkper_;
      let str = this.DISCWORD.current.value;
      var res = String(str.match("%"));
      if (res === "%") {
        var inputsprit = str.replace("%", "");
        // console.log(inputsprit);

        chkper_ = parseFloat(
          Number(this.state.allpriceforTax_) * (Number(inputsprit) / 100)
        ).toFixed(2);
      } else {
        chkper_ = this.DISCWORD.current.value;
      }
      this.DISCAMOUNT.current.value = chkper_;
      this.setState({ allpriceforTax_: this.state.allpriceforTax_ }); // เอาไว้ใช้คำนวนเบี้ยใหม่
    }
    setTimeout(() => {
      this._updateCalculatdi();
    }, 200);
  };
  _updateCalculatdi = () => {
    if (this.state.PriceType_code === 0) {
      let sum1 = this.state.allpriceforTax_ - this.DISCAMOUNT.current.value;
      //  มูลค่าสินค่า
      this.AFTERDISC.current.value = parseFloat(sum1).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TAXAMOUNT.current.value = parseFloat((sum1 * 7) / 100).toFixed(2);
    } else if (this.state.PriceType_code === 1) {
      let sum2 =
        ((this.state.allpriceforTax_ - Number(this.DISCAMOUNT.current.value)) *
          100) /
        107;
      //  มูลค่าสินค่า
      this.AFTERDISC.current.value = parseFloat(sum2).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TAXAMOUNT.current.value = parseFloat(
        this.state.allpriceforTax_ -
        (Number(this.AFTERDISC.current.value) +
          Number(this.DISCAMOUNT.current.value))
      ).toFixed(2);
    } else if (this.state.PriceType_code === 2) {
      // ----------------------------------------------------------------------------------------------------- commm
      //มูลค่าสินค่า
      this.AFTERDISC.current.value = parseFloat(
        this.state.allpriceforTax_ - Number(this.DISCAMOUNT.current.value)
      ).toFixed(2);
      //ภาษีมูลค่าเพิ่ม
      /* this.TAXAMOUNT.current.value = parseFloat(0).toFixed(2); */
    }
    // this.AFTERDISC.current.value = Allprice - sum;
    // มูลค่ารวมภาษี :
    this.TOTALAMOUNT.current.value = parseFloat(
      Number(this.AFTERDISC.current.value) + Number(this.TAXAMOUNT.current.value)
    ).toFixed(2);
    // รวมเงินทั้งสิ้น :
    this.DEBTAMOUNT.current.value = parseFloat(
      Number(this.AFTERDISC.current.value) + Number(this.TAXAMOUNT.current.value)
    ).toFixed(2);
  };


  _calculatdiscountkey = (e) => {
    if (e.key === "Enter") {
      this._calculatdiscount();
    }
  };

  Get_warehouse = (data) => {
    var DataValue = data.split("|");
    var Pr = this.state.products;
    var r = this.state.id;
    Pr[r].warehouse = DataValue[0];
    Pr[r].location = DataValue[2];
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 100);
  };

  checkStkwarehouse = (row) => {
    console.log(row);
    var col = this.state.products;

    var urll = "CSSTKWAREHOUSE/checkstockqty?productcode=" + col[row].productcode + "&warehouse=" + /* this.state.siteCodeUser */
      this.state.productcodeinrow1 + "&location=" + col[row].location;
    var chki = 0;
    axios.get(genURL(urll), { timeout: 60000 })
      .then((res) => {
        console.log(res);
        var chkloc = 0;
        for (var i = 0; i < res.data.length; i++) {
          chkloc = chkloc + 1;
          chki = chki + 1;
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
      })
      .then((_) => {
        setTimeout(() => {
          this.ReLoadData();
        }, 500);
      });
  };

  switchshowform = (e) => {
    this.setState({ showform: !this.state.showform });
  };
  loaddocMax() {
    if (this.Groupdata_code.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "!!! กรุณาเลือกกลุ่มข้อมูลก่อน" })
      return
    }
    this.GenerateDocno(this.Groupdata_code.current.value, "CSSaleRet")
  }

  addprodoctGroup = async () => {
    let item = this.state.products
    let itemlist = []

    for (let index = 0; index < item.length; index++) {
      // console.log("xxxxx", item.length);

      await Checkmaingroup(item[index].productcode).then(data => {
        // console.log("sssss",data);

        if (data == "") {
          itemlist[index] = {
            C0: item[index].C0,
            productcode: item[index].productcode,
            btn1: item[index].btn1,
            productname: item[index].productname,
            warehouse: item[index].warehouse,
            location: item[index].location,
            unitname: item[index].unitname,
            unitcode: item[index].unitcode,
            quantity: item[index].quantity,
            saleprice: item[index].saleprice,
            //price.toFixed(2),
            discountword: item[index].discountword,
            amount: item[index].amount,
            discountamount: item[index].discountamount,
            CNCODE: item[index].CNCODE,
            stocktype: item[index].stocktype,
            productgroup: data,
            refLineID: item[index].refLineID,
            itemtaxtype: item[index].itemtaxtype
          }
        } else {
          itemlist[index] = {
            C0: item[index].C0,
            productcode: item[index].productcode,
            btn1: item[index].btn1,
            productname: item[index].productname,
            warehouse: item[index].warehouse,
            location: item[index].location,
            unitname: item[index].unitname,
            unitcode: item[index].unitcode,
            quantity: item[index].quantity,
            saleprice: item[index].saleprice,
            //price.toFixed(2),
            discountword: item[index].discountword,
            amount: item[index].amount,
            discountamount: item[index].discountamount,
            CNCODE: item[index].CNCODE,
            stocktype: item[index].stocktype,
            productgroup: item[index].productgroup,
            refLineID: item[index].refLineID,
            itemtaxtype: item[index].itemtaxtype
          }
        }
        this.setState({ products: itemlist });
      })
      // if(index>= Number(item.length)){ 

      this.setState({ openBackdrop: false })
      // }
    }
  }
  setunitname = async (j) => {
    let item = this.state.products
    let itemlist = []
    // for (let index = 0; index < this.state.products.length; index++) {
    // console.log("sssssj", item[j].unitcode);
    //let unitname = ""
    await checkunit(item[j].unitcode).then(data => {
      // unitname = data  
      for (let index = 0; index < item.length; index++) {
        if (index !== j) {
          itemlist[index] = {
            C0: item[index].C0,
            productcode: item[index].productcode,
            btn1: item[index].btn1,
            productname: item[index].productname,
            warehouse: item[index].warehouse,
            location: item[index].location,
            unitname: item[index].unitname,
            unitcode: item[index].unitcode,
            quantity: item[index].quantity,
            saleprice: item[index].saleprice,
            //price.toFixed(2),
            discountword: item[index].discountword,
            amount: item[index].amount,
            discountamount: item[index].discountamount,
            CNCODE: item[index].CNCODE,
            stocktype: item[index].stocktype,
            productgroup: item[index].productgroup,
            itemtaxtype: item[index].itemtaxtype
          }
        } else {
          itemlist[j] = {
            C0: item[j].C0,
            productcode: item[j].productcode,
            btn1: item[j].btn1,
            productname: item[j].productname,
            warehouse: item[j].warehouse,
            location: item[j].location,
            unitname: data,
            unitcode: item[j].unitcode,
            quantity: item[j].quantity,
            saleprice: item[j].saleprice,
            //price.toFixed(2),
            discountword: item[j].discountword,
            amount: item[j].amount,
            discountamount: item[j].discountamount,
            CNCODE: item[j].CNCODE,
            stocktype: item[j].stocktype,
            productgroup: item[j].productgroup,
            itemtaxtype: item[j].itemtaxtype
          }
        }
      }
      this.setState({ products: itemlist });
    })
    //  }
  }
  SELECTCNCODE = (cell, row, enumObject, rowIndex) => {
    var btnShow = "";
    if (row.productcode) {
      btnShow = (
        <div>
          <SelectDatas
            origin="cscncode"  // ประเภท
            valueSelect={e => this.SelectSetData("cscncode" + String(rowIndex), e, String(rowIndex))} // รับค่ากลับ
            title="-"
            defaultselect={row.CNCODE}// ค่าเริ่มต้นของ ประเภทราคา
            opentitle={true}
          />
        </div >
      )
    }
    return <div>{btnShow}</div>;
  };
  openDialog = async (e) => {
    this.setState({ selectpopup: e })
    if (this.state.SaleDate === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" })
      return
    }
    if (this.ARCODE.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
      return
    }
    if (this.ARNAME.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
      return
    }
    if (e === "SelSaleRetReqRef") {
      this.setState({ typeFullScreenDialogs: e })
      this.setState({ titleFullScreenDialogs: "ค้นหาใบขอคืนสินค้า-SelSaleRetReqRef" })
      this.setState({ openFullScreenDialogs: true })
    }

    if (e === "Inputtax") {
      let arrforparm = []
      arrforparm.push(this.state.SaleDate)
      // arrforparm.push(this.ARCODE.current.value)
      arrforparm.push("")
      // arrforparm.push(this.ARNAME.current.value)
      arrforparm.push("")
      arrforparm.push(this.TAXRATE.current.value)
      // ข้อมูลในตาราง
      arrforparm.push(this.state.inputtax)
      //  อัตราขอคืนได้
      arrforparm.push(this.state.Refundablerate)
      // มูลค่าที่ขอคืนได้
      arrforparm.push(this.state.Refundablevalue)
      // ภาษีที่ขอคืนได้
      arrforparm.push(this.state.Taxrefund)
      // รวมยอดภาษี
      arrforparm.push(this.state.Totaltax)
      setTimeout(() => {
        this.setState({ Inputtaxall: arrforparm })
        this.setState({ typeFullScreenDialogs: e })
        this.setState({ titleFullScreenDialogs: "เลือกใบกำกับภาษีหลายใบ" })
        this.setState({ openFullScreenDialogs: true })
      }, 100);
    }
    if (e === "TaxWithholding") {

      let Data = []
      Data = await {
        from: "CSOTHEREXPENSE",
        defulttable: this.state.tableother,
        Deliverydate: this.state.Deliverydate,
        Notax: this.state.Notax,
        Payablecode: this.state.Payablecode,
        Payablename: this.state.Payablename,
        taxtypecode: this.state.taxtypecode,
        taxtype: this.state.taxtype,
        Incometypecode: this.state.Incometypecode,
        Incometype: this.state.Incometype,
        Remark: this.state.Remark,
        Deductionconditions: this.state.Deductionconditions,
        Taxrate: this.state.Taxrate,
        Amountbeforetax: this.state.Amountbeforetax,
        Withholdingtax: this.state.Withholdingtax,
        Actingonbehalf: this.state.Actingonbehalf,
        Totaltax: this.state.Totaltax,
      }
      this.setState({ Withholding: Data })
      this.setState({ typeFullScreenDialogs: e })
      this.setState({ titleFullScreenDialogs: "บันทึกภาษีหัก ณ ที่จ่าย" })
      this.setState({ openFullScreenDialogs: true })
    }
    if (e === 'cashRepayment') {
      this.setState({ typeFullScreenDialogs: e })
      this.setState({ titleFullScreenDialogs: "cashRepayment" })
      this.setState({ openFullScreenDialogs: true })
    }
  }
  ReturnData = async (e) => {
    // this.setState({ openFullScreenDialog: e[0] })
    var selectpopup = this.state.selectpopup
    if (selectpopup === "SelSaleRetReqRef") {
      this.CloseDialog(e[0])
      this.setState({ CNTYPE: "0" });
      //เลือกใบส่งของ/ใบกำกับ 
      let row = this.state.products;
      var j = this.state.products.length
      this.REFAMOUNT.current.value = !e[3] ? (0).toFixed(2) : Number(e[3]).toFixed(2)
      this.DIFFAMOUNT.current.value = !e[4] ? (0).toFixed(2) : Number(e[3]).toFixed(2)
      var data = e[1]
      if (data) {
        for (let i = 0; i < data.length; i++) {

          row[j] = {
            productcode: data[i].PRODUCTCODE,
            productname: data[i].PRODUCTNAME,
            REFINVOICE: data[i].REFINVOICE,
            warehouse: data[i].WAREHOUSE,
            location: data[i].LOCATION,
            unitname: data[i].UNITNAME,
            unitcode: data[i].UNITCODE,
            quantity: data[i].QUANTITY,
            saleprice: data[i].UNITPRICE,
            discountword: data[i].DISCWORD,
            refLineID: data[i].REFLINEID ? data[i].REFLINEID : "0",
            productgroup: "",
            stocktype: data[i].STOCKTYPE,
            itemtaxtype: data[i].ITEMTAXTYPE ? data[i].ITEMTAXTYPE : "0",
            PRODUCTSET: data[i].PRODUCTSET,
            REFQTY: "",
            PK_LOTID: data[i].PK_LOTID,
            returnpopup: "2",
            DOCNO: data[i].DOCNO,//ตัดเลือใบขอรับคืน
            REFDOCNO: data[i].REFDOCNO,
            PRODUCTSETCODE: data[i].PRODUCTCODE,
            REFLINEID2: data[i].REFLINEID2,
          }
          j++
        }
        console.log(row);
        this.setState({ products: [...row] });
        setTimeout(() => {
          console.log(e[2]);
          if (e[2]) {
            this.CreditCode_code.current.value = e[2];
            this.CreditCode.current.value = CreditCode(e[2]);
          }
          let data2 = e[3]
          console.log(data2);
          this.setState({ CNTYPE: data2.CNTYPE });
          if (data2.DEPARTMENT !== "") {
            this.onAddValue("Department", data2.DEPARTMENT);
          }
          if (data2.SITECODE !== "") {
            this.onAddValue("Branch", data2.SITECODE);
          }
          // this.onAddValue("ARCODE", this.ARCODE.current.value)
          if (data2.TAXTYPE !== "") {
            this._pricetype(data2.TAXTYPE);
          }
          if (data2.REMARK) {
            this.REMARK.current.value = data2.REMARK
          }
          this.ReLoadData();
        }, 300);
      }
    }
    if (selectpopup === "Inputtax") {
      this.CloseDialog(e[0])
      if (e !== "") {
        this.setState({ inputtax: e[1] })
        this.setState({ Refundablerate: e[2] })
        this.setState({ Refundablevalue: e[3] })
        this.setState({ Taxrefund: e[4] })
        this.setState({ Totaltax: e[5] })

      } else {
        this.setState({ inputtax: this.state.inputtax })
        this.setState({ Refundablerate: this.state.Refundablerate })
        this.setState({ Refundablevalue: this.state.Refundablevalue })
        this.setState({ Taxrefund: this.state.Taxrefund })
        this.setState({ Totaltax: this.state.Totaltax })
      }
    }
    if (selectpopup === "TaxWithholding") {
      this.CloseDialog(e[0])
      console.log(e);
      if (e[1]) {
        this.setState({ tableother: e[1] })
      }
      if (e[2]) {
        this.setState({ Deliverydate: e[2] })
      }
      if (e[3]) {
        this.setState({ Docgroupcode: e[3] })
      }
      if (e[4]) {
        this.setState({ Notax: e[4] })
      } else if (e[4] === "") {
        this.setState({ Notax: "" })
      }
      if (e[5]) {
        this.state.Payablecode = e[5]
      }
      if (e[6]) {
        this.state.Payablename = e[6]
      }
      if (e[7]) {
        this.setState({ taxtypecode: e[7] })
      } else if (e[7] === "") {
        this.setState({ taxtypecode: "" })
        this.setState({ taxtype: "" })
      }
      if (e[8]) {
        this.setState({ taxtype: e[8] })
      }
      if (e[9]) {
        this.setState({ Incometypecode: e[9] })
      }
      if (e[10]) {
        this.setState({ Incometype: e[10] })
      } else if (e[10] === "") {
        this.setState({ Incometypecode: "" })
        this.setState({ Incometype: "" })
      }
      if (e[11]) {
        this.setState({ Remark: e[11] })
      } else if (e[11] === "") {
        this.setState({ Remark: "" })
      }
      if (e[12]) {
        this.setState({ Deductionconditions: e[12] })
      }
      if (e[13]) {
        this.setState({ Taxrate: e[13] })
      }
      if (e[14]) {
        this.setState({ Amountbeforetax: e[14] })
      }
      if (e[15]) {
        this.setState({ Withholdingtax: e[15] })
      }
      if (e[16]) {
        this.setState({ Actingonbehalf: e[16] })
      }
      if (e[17]) {
        this.setState({ Totaltax: e[17] })
      }
    }
  }
  onClickTopbar = (e) => {
    // this.setState({ defaultselect: "" })
    console.log(e);
    switch (e) {
      case "save":
        this._connectsaveData()
        break;
      case "new":
        this.ResetThisPage()
        break;
      case "print":
        this._print.bind(null)
        break;
      case "search":
        // this.setState({ SwitchSearchDoc: true });
        //ชื่อ
        this.setState({ typeFullScreenDialogs: e })
        //open
        this.setState({ openFullScreenDialogs: true })
        //title
        this.setState({ titleFullScreenDialogs: "บันทึกใบขอสั่งซื้อสินค้า" })
        break;
      case "SelSaleRef3":
        this.Switch_SelSaleRef3("SelSaleRef3")
        break;
      case "SelSaleRetReqRef":
        this.openDialog("SelSaleRetReqRef")
        break;
      case "SelARDepositUse":
        this.Switch_SelARDepositUse("SelARDepositUse")
        break;
      case "TaxWithholding":
        this.openDialog("TaxWithholding")
        break;
      case "Inputtax":
        this.openDialog("Inputtax")
        break;
      case "cashRepayment":
        this.openDialog("cashRepayment")
        break;
      default:
        break;
    }
  }
  rowStyleFormat = (row, rowIdx) => {
    // console.log(row, rowIdx);
    let color = ""
    if (row) {
      if (row.PRODUCTSET === "1") {
        color = 'blue'
      } else if (row.PRODUCTSET === "2") {
        color = '#22AF19'
      }
    }
    return { color: color }
  }

  CloseDialog = (e) => {
    this.setState({ openFullScreenDialogs: e })
  }
  propsvalue = (data) => {
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse })
      this.setState({ defaultlocetion: data.location })
    }
  }
  render() {
    const type = this.state.typeFullScreenDialogs
    return (
      <div className="PSApp" onClick={this.onClick}
        onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur}
      >
        <FullScreenDialogs open={this.state.openFullScreenDialogs} title={this.state.titleFullScreenDialogs} closeDialog={e => this.CloseDialog(e)}>
          {type === "SelSaleRetReqRef" ? <PopUpSelSaleRetReqRef parm={{ ARCODE: this.ARCODE.current.value }} resdata={e => this.ReturnData(e)} /> : null}
          {type === "TaxWithholding" ? <Withholding parm={this.state.Withholding} resdata={e => this.ReturnData(e)} /> : null}
          {type === "Inputtax" ? <Inputtax parm={this.state.Inputtaxall} resdata={e => this.ReturnData(e)} /> : null}
          {type === "search" ? <PopUpSearchDoc closePopup={e => this.CloseDialog(e)} Get_Popup={this._reCHK} from="CSSALERET" userSite={this.state.siteCodeUser} /> : null}
          {type === "Groupdata" || type === "Department" || type === "Branch" || type === "CreditCode" ? <PopUpOther closePopup={e => this.CloseDialog(e)} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} from="CSSaleRet" userSite={this.state.siteCodeUser} /> : null}
          {type === "Search_ARCode" ? <PopupArcode closePopup={e => this.CloseDialog(e)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
          {type === "Search_CSVINVSALEREF" ? <PopUpReturnProduct closePopup={e => this.CloseDialog(e)} Get_SelSaleRef3={this.Get_SelSaleRef3} type={"SelSaleRef3"} ARCODE={this.ARCODE.current.value} /> : null}
          {type === "Search_Table" ? <PopUpItem closePopup={e => this.CloseDialog(e)} Get_PopUpItem={this.Get_PopUpItem} userSite={this.state.siteCodeUser} from="CSSALERET" /> : null}
          {type === "setwarehousetable" ? <PopUpwarehouse closePopup={e => this.CloseDialog(e)} type="setdefaultwarehouse" Get_PopUpOther={this.Get_warehouse} productcodeinrow={this.state.productcodeinrow} productcodeinrow1={this.state.productcodeinrow1} from="CSSALERET" /> : null}
          {type === "CSSELSALERETREQREF" ? <PopUpReturnProductSub2 closePopup={e => this.CloseDialog(e)} Get_SelARDepositUse={this.Get_SelSaleRef3} type={this.state.PopUpTYpeSelARDepositUse} ARCODE={this.ARCODE.current.value.trim()} TAXTYPE={this.state.PriceType_code} /> : null}
          {/* cashRepayment */}
          {type === "cashRepayment" ? <PopUpSaveMoneyExp AmountPayable={this.state.AmountPayable} date={this.state.SaleDate} Customer={this.ARCODE.current.value} from="CSSALERETREQ" pms="R|1|1|1|1|1|1" get_PopUpSaveMoney={this.get_PopUpSaveMoney} closePopup={() => { this.setState({ PopUpSaveMoney: false }) }} /> : null}

        </FullScreenDialogs>
        {this.state.showform ? (<PopUpReport close={this.switchshowform} url={this.state.urlsend} />) : null}
        {this.state.PopUpSaveMoney ? (<PopUpSaveMoneyExp AmountPayable={this.state.AmountPayable} date={this.state.SaleDate} Customer={this.ARCODE.current.value} from="CSSALERETREQ" pms="R|1|1|1|1|1|1" get_PopUpSaveMoney={this.get_PopUpSaveMoney} closePopup={() => { this.setState({ PopUpSaveMoney: false }) }} />) : null}
        <Topbar
          listmenu={listmenu}
          title="บันทึกรับคืนสินค้าและบริการ"
          onClick={e => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom">
          <Grid>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row className="show-grid">
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">รหัสลูกค้า</span>
                        <input type="text" className="form-control" name="ARCODE" ref={this.ARCODE} />
                        <span onClick={() => this.Switch_PopupArcode("Search_ARCode")} id="iconCustomerCode" className="input-group-addon icon">
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={8} md={8} lg={8}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span id="iconCustomerName" className="input-group-addon icon">
                          <i className="fas fa-user"></i>
                        </span>
                        <input type="text" className="form-control" readOnly ref={this.ARNAME} />
                        {/* <span className="input-group-addon icon"></span> */}
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">กลุ่มข้อมูล</span>
                        <input type="text" className="form-control hidden" ref={this.Groupdata_code} />
                        <input type="text" className="form-control" name="Groupdata" ref={this.Groupdata} />
                        <span id="iconGroupdata" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}>
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <MaterialUIPickers title="วันที่ลดหนี้"
                      DateValue={e => this.SelectSetData("Calendar", e)}
                      defaultdate={this.state.SaleDate}
                      open={this.state.checkenableInput['DOCDATE']} />
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">ใบลดหนี้/รับคืน</span>
                        <input type="text" className="form-control" ref={this.DeliNumber} readOnly />
                        <span id="iconTaxNumber" className="input-group-addon icon">
                          <i className="fas fa-sync-alt" onClick={e => this.loaddocMax()}></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">ใบกำกับภาษี</span>
                        <input type="text" className="form-control" ref={this.TAXNO} readOnly={this.state.checkenableInput["TAXNO"] ? 0 : 1} />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <MaterialUIPickers title="วันที่ใบกำกับ"
                      DateValue={e => this.SelectSetData("Calendar2", e)}
                      defaultdate={this.state.TAXDATE}
                      Open={this.state.OpenTAXDATE} />
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">รหัสเครดิต</span>
                        <input type="text" className="form-control hidden" ref={this.CreditCode_code} />
                        <input type="text" className="form-control" ref={this.CreditCode} readOnly />
                        <span id="iconCreditCode" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "CreditCode")}>
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <SelectDatas
                          origin="STOCKPROC1"  // ประเภทการคืน
                          valueSelect={e => this.SelectSetData("STOCKPROC", e)} // รับค่ากลับ
                          title="ประเภทการคืน"
                          defaultselect={this.state.STOCKPROC}// ค่าเริ่มต้นของ ประเภทการคืน
                        />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <SelectDatas
                          origin="PriceType"  // ประเภท
                          valueSelect={e => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                          title="ประเภทราคา"
                          defaultselect={this.state.PriceType_code}// ค่าเริ่มต้นของ ประเภทราคา
                        />
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Grid>
          <Grid>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row className="show-grid">
                <Col xs={12} sm={8} md={8} lg={8}>
                  <Row className="show-grid">
                    <CustomInputtext title="คลังเริ่มต้น" value={this.state.defaultvaluewarehouse} disabledvalue={true} of_title={false} of_btn={false}
                      source={"CSWAREHOUSEALL"}
                      propsvalue={this.propsvalue}
                    />
                  </Row>
                </Col>
              </Row>
            </Col>
          </Grid>
        </div>
        {/* alert สอบถามการเปลี่ยนแปลงราคา */}
        <div className="container-fluid">
          <div >
            <Modal show={this.state.show1} size="sm" /*กดข้างนอก Modal onHide={() => { this.setState({ show1: false }) }}  */ >
              <Modal.Header style={{
                // backgroundColor: 'rgba(190, 200, 215, 0.9)',
                borderRadius: '10px 10px 0px 0px'
              }}>
                <div className="PopUpOtherDivH1"><i className="fas " style={{ color: 'black' }}> ปรับราคา </i></div>
                <div className="PopUpOtherDivH2"><i className="fas fa-times" style={{ color: 'white' }} onClick={() => { this.setState({ show1: false }) }}></i></div>
              </Modal.Header>
              <Modal.Body style={{ fontSize: '20px', left: '12px' }}>ต้องการปรับราคาขายต่อหน่วยใหม่หรือไม่! </Modal.Body>
              <Modal.Footer style={{
                // backgroundColor: 'rgba(190, 200, 215, 0.9)',
                borderRadius: '0px 0px 10px 10px'
              }}>
                <Button variant="secondary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={() => { this.AddDataTable2(); this.setState({ show1: false }) }}> ใช่ </Button>
                <Button variant="primary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={() => { this.setState({ show1: false }) }}> ไม่ใช่ </Button>
              </Modal.Footer>
            </Modal>
          </div>

          <div className="PSAppTable">
            <BootstrapTable
              data={this.state.products}
              trClassName="trClassName"
              tableHeaderClass="trClassName"
              options={{ noDataText: "...", onRowClick: this.onRowClick, }}
              cellEdit={{
                mode: "click",
                blurToSave: true,
                beforeSaveCell: this.onBeforeSaveCell,
                afterSaveCell: this.onAfterSaveCell,
              }}
              trStyle={this.rowStyleFormat}
              // keyBoardNav={{ enterToEdit: true }} 
              height="400"
            >
              <TableHeaderColumn row="0" rowSpan="2" dataField="C0" isKey width="35" dataAlign="center" dataFormat={this._chkload.bind(this)}></TableHeaderColumn>
              <TableHeaderColumn row="0" colSpan="2" editable={this.state.sEnableedit} headerAlign="center" width="150" className="colbuttomhidden">  <div align="center"> รหัสสินค้า </div></TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="productcode" editable={this.state.col1} dataAlign="left" width="120">  <div align="center">  </div></TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="Btn1" editable={false} dataAlign="center" width="30" dataFormat={this._cellButton.bind(this)} columnClassName="columnClassNameFormat1">  <i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="productname" editable={false} dataAlign="left" width="140"> <div align="center"> ชื่อสินค้า </div> </TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="REFINVOICE" editable={this.state.col} dataAlign="left" width="140"> <div align="center"> ใบส่งของ </div> </TableHeaderColumn>
              <TableHeaderColumn row="0" colSpan="2" dataAlign="center" className="colbuttomhidden" width="120"> <div align="center"> คลัง </div> </TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="warehouse" editable={this.state.col} dataAlign="center" width="90"></TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="btn_C3" editable={false} dataAlign="center" width="30" dataFormat={this._cellButton_btn_C3.bind(this)} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
              <TableHeaderColumn row="0" colSpan="2" dataAlign="center" className="colbuttomhidden" width="120"> <div align="center"> ตำแหน่งเก็บ </div> </TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="location" editable={this.state.col} dataAlign="center" width="90"></TableHeaderColumn>
              <TableHeaderColumn row="1" dataField="btn_C4" editable={false} dataAlign="center" width="30" dataFormat={this._cellButton_btn_C4.bind(this)} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="unitname" editable={false} dataAlign="center" width="90"> <div align="center"> หน่วย </div> </TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="quantity" editable={this.state.col} dataAlign="center" width="90" >   <div align="center"> ปริมาณ </div> </TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="saleprice" editable={this.state.col} dataAlign="right" width="90">  <div align="center"> ราคาขาย </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="discountword" editable={false}/* editable={this.state.reduce} */ dataAlign="right" width="90">  <div align="center"> ลด </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="discountamount" editable={false} dataAlign="right" width="90"> <div align="center"> จำนวนเงิน(ส่วนลด) </div> </TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="amount" editable={false} dataAlign="right" width="90"><div align="center"> จำนวนเงิน </div></TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="CNCODE" editable={false} dataAlign="center" dataFormat={this.SELECTCNCODE.bind(this)} width="130"><div align="center"> สาเหตุ </div></TableHeaderColumn>
              <TableHeaderColumn row="0"
                // rowSpan="2" 
                dataField="productgroup" width="90" editable={false} hidden>productgroup </TableHeaderColumn>
              <TableHeaderColumn row="0"
                // rowSpan="2"
                dataField="refLineID" width="90" editable={false} hidden>refLineID  </TableHeaderColumn>
              <TableHeaderColumn row="0"
                // rowSpan="2" 
                dataField="unitcode" width="90" editable={false} hidden>unitcode </TableHeaderColumn>
              <TableHeaderColumn row="0"
                rowSpan="2"
                dataField="stocktype" width="90" editable={false} >stocktype</TableHeaderColumn>
              <TableHeaderColumn row="0"
                rowSpan="2"
                dataField="itemtaxtype" width="90" editable={false} >itemtaxtype</TableHeaderColumn>
              <TableHeaderColumn row="0"
                rowSpan="2"
                dataField="PRODUCTSET" width="90" editable={false} >PRODUCTSET</TableHeaderColumn>
              <TableHeaderColumn row="0"
                rowSpan="2"
                dataField="REFQTY" width="90" editable={false} >REFQTY</TableHeaderColumn>
              <TableHeaderColumn row="0"
                rowSpan="2"
                dataField="PK_LOTID" width="90" editable={false} >PK_LOTID</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="returnpopup" width="90" editable={false} >returnpopup</TableHeaderColumn>
              <TableHeaderColumn row="0" rowSpan="2" dataField="PRODUCTSETCODE" width="90" editable={false} >PRODUCTSETCODE</TableHeaderColumn>
            </BootstrapTable>
          </div>
          <Grid>
            <Col xs={12} sm={8} md={8} lg={8}>
              <Row className="show-grid">
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid">
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">พนักงานขาย</span>
                        <input type="text" className="form-control hidden" ref={this.Csuser_code} />
                        <input type="text" className="form-control" ref={this.Csuser} readOnly />
                        <span id=" " className="input-group-addon icon">
                          <i className="fas fa-sync-alt" onClick={() => this.onAddValue("Csuser", this.state.siteCodeUser1)}></i>
                        </span>
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">แผนก</span>
                        <input type="text" className="form-control hidden" ref={this.Department_code} />
                        <input type="text" className="form-control" name="Department" ref={this.Department} />
                        <span id="iconDepartment" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Department")}>
                          <i><ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 project" >
                        <SelectDatas
                          origin="PROJECT"  // โครงการ
                          valueSelect={e => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                          title="โครงการ"
                          defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                        />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">สาขา</span>
                        <input type="text" className="form-control hidden" ref={this.Branch_code} />
                        <input type="text" className="form-control" name="Branch" ref={this.Branch} />
                        <span id="iconBranch" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Branch")}>
                          <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                        </span>
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">ยอดใบกำกับภาษีเดิม</span>
                        <input type="number" className="form-control Price" ref={this.REFAMOUNT} />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">มูลค่าที่ถูกต้อง</span>
                        <input type="number" className="form-control Price" ref={this.DIFFAMOUNT} />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <SelectDatas
                          origin="PriceReturnType"  // ประเภทการคืนเงิน
                          valueSelect={e => this.SelectSetData("PriceReturnType", e)} // รับค่ากลับ
                          title="ประเภทการคืนเงิน"
                          defaultselect={this.state.CNTYPE}// ค่าเริ่มต้นของ ประเภทการคืนเงิน
                        />
                      </div>
                    </div>
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <SelectDatas
                          origin="cscncode"  // สาเหตุ
                          valueSelect={e => this.SelectSetData("cscncode", e, "")} // รับค่ากลับ
                          title="สาเหตุ"
                          defaultselect={this.state.cscncode}// ค่าเริ่มต้นของ สาเหตุ
                        />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid">
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">สกุลเงิน</span>
                        <input type="text" className="form-control" defaultValue="บาท" />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid">
                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <SelectDatas
                          origin="SaleType"  // ประเภทการขาย
                          valueSelect={e => this.SelectSetData("SaleType", e)} // รับค่ากลับ
                          title="ประเภทการขาย"
                          defaultselect={this.state.SaleType}// ค่าเริ่มต้นของ ประเภทการขาย
                        />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid">
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">อัตราแลกเปลี่ยน</span>
                        <input type="text" className="form-control Price" value="1.0000000" readOnly />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="show-grid">
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">หมายเหตุ</span>
                        <input type="text" className="form-control" ref={this.REMARK} tabIndex={6} />
                      </div>
                    </div>
                  </Row>
                </Col>

              </Row>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <Row className="show-grid">
                <Col xs={12} sm={12} md={12} lg={12} >
                  <Row className="show-grid">
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">รวมจำนวนเงิน</span>
                        <input type="" className="form-control Price" ref={this.SUMAMOUNT1} readOnly />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">ส่วนลด</span>
                        <input type="text" min="1" max="100" className="form-control Price" ref={this.DISCWORD}
                          // onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                          onKeyDown={this.Cal_Price1}
                          onBlur={this.Cal_Price.bind(null)}
                        />
                        <span className="input-group-addon icon">
                          <i className="fas fa-percentage"></i>
                        </span>
                        <input type="text" className="form-control Price" ref={this.DISCAMOUNT} readOnly tabIndex={4} />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">มูลค่าสินค้า</span>
                        <input type="text" className="form-control Price" ref={this.AFTERDISC} readOnly />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">ภาษีมูลค่าเพิ่ม</span>
                        <input type="text" className="form-control Price" ref={this.TAXRATE}
                          onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                          onKeyDown={this.Cal_Price1}
                          onBlur={this.Cal_Price.bind(null)} />
                        <span className="input-group-addon icon">
                          <i className="fas fa-percentage"></i>
                        </span>
                        <input type="text" className="form-control Price" ref={this.TAXAMOUNT} readOnly />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon ">มูลค่ารวมภาษี</span>
                        <input type="text" className="form-control Price" ref={this.TOTALAMOUNT} readOnly />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon"> มูลค่ายกเว้น</span>
                        <input type="text" className="form-control Price" ref={this.SUMAMOUNT2} readOnly />
                      </div>
                    </div>
                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon"> รวมเงินทั้งสิ้น</span>
                        <input type="text" className="form-control Price" ref={this.DEBTAMOUNT} readOnly />
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col xs={12} sm={12} md={12} lg={12}>
              <Row className="show-grid">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Panel>
                    <Panel.Heading>
                      <Panel.Title componentClass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <Col xs={12} sm={12} md={12} lg={12} >
                        <Row className="show-grid">
                          <Col xs={12} sm={12} md={4} lg={4}>
                            <div className="row ">
                              <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                  <span className="input-group-addon">รหัสลูกค้าจริง</span>
                                  <input type="text" className="form-control Price" ref={this.Arcode2} tabIndex={7} />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col xs={12} sm={12} md={4} lg={4}>
                          </Col>
                          <Col xs={12} sm={12} md={4} lg={4}>
                          </Col>
                        </Row>
                      </Col>
                    </Panel.Body>
                  </Panel>
                </Col>
              </Row>
            </Col>
          </Grid>
          <Snackbar place="br"
            color={this.state.color}
            icon={this.state.icon}
            autoClose={this.state.autoClose}
            message={this.state.messagealert}
            open={this.state.opensnackbar}
            closeNotification={() => { this.setState({ opensnackbar: false }) }}
            close />
        </div>
      </div >
    );
  }
}
